import React from 'react';

interface RouletteWheelIconProps {
  size?: number;
}

const RouletteWheelIcon: React.FC<RouletteWheelIconProps> = ({ size = 28 }) => {
  const wedges = Array.from({ length: 18 }, (_, index) => index);

  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true" focusable="false">
      <circle cx="50" cy="50" r="48" fill="#111" />
      {wedges.map((index) => {
        const startAngle = (index * 360) / 18;
        const endAngle = ((index + 1) * 360) / 18;
        const largeArc = endAngle - startAngle > 180 ? 1 : 0;
        const x1 = 50 + 45 * Math.cos((Math.PI * startAngle) / 180);
        const y1 = 50 + 45 * Math.sin((Math.PI * startAngle) / 180);
        const x2 = 50 + 45 * Math.cos((Math.PI * endAngle) / 180);
        const y2 = 50 + 45 * Math.sin((Math.PI * endAngle) / 180);
        const fill = index % 2 === 0 ? 'var(--primary-colour)' : 'var(--secondary-colour)';

        return (
          <path
            key={index}
            d={`M 50 50 L ${x1} ${y1} A 45 45 0 ${largeArc} 1 ${x2} ${y2} Z`}
            fill={fill}
            stroke="#111"
            strokeWidth="1"
          />
        );
      })}
      <circle cx="50" cy="50" r="14" fill="#fff" />
      <line x1="50" y1="38" x2="50" y2="62" stroke="#111" strokeWidth="2" />
      <line x1="38" y1="50" x2="62" y2="50" stroke="#111" strokeWidth="2" />
    </svg>
  );
};

export default RouletteWheelIcon;
